export default __webpack_public_path__ + "static/media/img-index-02-funcionalidades.1eb20382.png";